import ApiStatus from 'component/ApiStatus';
import PaginationLoader from 'component/PaginationLoader';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { ClientDetailConsultationForm, ClientDetailConsultationFormTab, ClientformApi } from 'store/slices/clientformSlice';
import config from "../../../../config"
import ClientFormDetails from './ClientFormDetails';
import { shouldRenderClientHistoryEmptyState } from '../clientHistoryViewState';
import { formatClientFormCompletedDate } from './formDate';
import { usercheckAccess } from '../../../../helpers/Functions';
import { profileSyncBadge, profileSyncForSubmission } from './profileSyncContract';

const Forms = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  const canUpdateClient = usercheckAccess("clients.update", currentUser);
  void (currentUser && currentUser.role_id);
  useSelector(state => state.salonmodule.isAccess);
  const clientformApiStatus = useSelector((state) => state.clientform.isApiStatus);
  const clientformViews = useSelector((state) => state.clientform.isListView);
  const clientformListError = useSelector((state) => state.clientform.isListViewError);
  const detail = useSelector((state) => state.client.isDetailData);
  const isclientDetailConsultationFormTab = useSelector((state) => state.clientform.isclientDetailConsultationFormTab);
  const formStatus = clientformApiStatus && clientformApiStatus.ClientformApi;
  const formRows = clientformViews && Array.isArray(clientformViews.data) ? clientformViews.data : [];
  const showEmptyState = shouldRenderClientHistoryEmptyState({
    hasRows: formRows.length > 0,
    isLoading: formStatus === "loading",
    error: clientformListError,
  }) && formStatus === "succeeded";
  // console.log(clientformApiStatus.ClientformApi)
  // console.log(clientformApiStatus)

  const fetchDataInvoiceList = () => {
    dispatch(ClientformApi({ client_id: detail.id, next_page_url: clientformViews.next_page_url }));
  };

  const [isFetching, setIsFetching] = useState(false);
  const loadMoreItemsList = () => {
    setIsFetching(true);
    dispatch(ClientformApi({ next_page_url: clientformViews && clientformViews.next_page_url, client_id: detail.id }));
    //mocking an API call
    setTimeout(() => {
      setIsFetching(false);
    }, 2000);
  };

  return (
    <div>
      <div className="drawer-header">
        <h2 className="mb-4 pe-md-5 mb-lg-5">{t("Forms")}</h2>
      </div>
      {clientformListError && (
        <div className="alert alert-danger mb-3" role="alert">
          {clientformListError}
        </div>
      )}
      <div className="content-wrp" id="formlist">
        {formRows.length > 0 && (formStatus === "succeeded" || formStatus === "failed") ? (
          <InfiniteScroll className="content-wrp row gx-0" dataLength={clientformViews.data.length} next={fetchDataInvoiceList} scrollableTarget="formlist" hasMore={clientformViews.next_page_url ? true : false} loader={<PaginationLoader />}>
            {Object.keys(clientformViews.data).map((item, i) => {
              let form = clientformViews && clientformViews.data && clientformViews.data[item].form ? clientformViews.data[item].form : "";
              let title = clientformViews.data[item].form && form.title ? form.title : "";
              let is_active_at = clientformViews && clientformViews.data && clientformViews.data[item].is_status_at ? clientformViews.data[item].is_status_at : "";
              let completedDate = formatClientFormCompletedDate(is_active_at);
              const submission = clientformViews.data[item];
              const syncBadge = profileSyncBadge(profileSyncForSubmission(submission));
              return (
                <div className="text-decoration-none event-box-pink mb-3" href="" key={item && item.id ? item.id : i}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="left-clientforms-contents">
                      <h6 className="mb-1 color-wine fw-semibold">{t(title ? title :"")}</h6>
                      <h6 className="mb-1">{t(`Completed : ${completedDate ? completedDate : ""}`)}</h6>
                      {syncBadge && <span className={`badge bg-${syncBadge.tone}`}>{t(syncBadge.label)}</span>}
                    </div>
                    <div className="right-clientforms-contents">
                      <a className="btn btn-outline btn-sm" onClick={()=>{
                          dispatch(ClientDetailConsultationFormTab("open"));
                          dispatch(ClientDetailConsultationForm(submission));
                        }}>{t("View Form")}</a>
                    </div>
                  </div>
                </div>
              )
            })}
            {!isFetching && clientformViews.next_page_url && (
              <div className="col-2 m-auto p-3 text-center">
                <button onClick={loadMoreItemsList} className="btn btn-primary">
                  {t("More")}
                </button>
              </div>
            )}
          </InfiniteScroll>
        ) : (
          <>
            {formStatus === "loading" ? (
              <ApiStatus actionType='clientconsultationforms' />
            ) : showEmptyState ? (
              <div className="complete-box text-center d-flex flex-column justify-content-center mt-xl-4">
                <div className="complete-box-wrp text-center">
                  <img src={config.imagepath + "docs.png"} alt="" className="mb-md-4 mb-3" />
                  <h5 className="mb-2 fw-semibold">{t("There are no forms filled.")}</h5>
                </div>
              </div>
            ) : null}
          </>
        )}
      </div>
      {isclientDetailConsultationFormTab && <ClientFormDetails canUpdateClient={canUpdateClient} />}
    </div>
  )
}

export default Forms;
